require( './bootstrap' );
// add lazy-load supported
import LazyLoad from "vanilla-lazyload";

let myLazyLoad = new LazyLoad();


$.each( $( '[data-toggle="jackpot"]' ), function () {
	initializeJackpot( $( this ).attr( "id" ), $( this ).data( 'jack' ) )
} );


var startText = $( ".js-bonus-button" ).html();
$( ".js-bonus-button" ).on( "click", function () {
	$( this ).hasClass( "remove" ) ? (
		$( this ).removeClass( "remove" ).html( startText ), $( this ).parent().next().slideUp()
	) : (
		$( ".js-bonus-button" ).removeClass( "remove" ).html( startText ), $( this ).html(
			"Скрыть &gt;&gt;&gt;" ).addClass( "remove" ), $( ".bonus-item__content" ).slideUp(), $(
			this ).parent().next().slideDown()
	)
} )

$( '#nav-icon' ).on( 'click', function () {
	$( this ).toggleClass( 'open' );
	$( 'header ul' ).slideToggle( 'medium', function () {
		if ( $( this ).is( ':visible' ) ) {
			$( this ).css( 'display', 'flex' );
		}
	} );
} );


//--------------------------------------------------------------------------------------------------------------
// JS FILTER START
//--------------------------------------------------------------------------------------------------------------

var jsFilter = document.getElementById( 'filter-producer' ), // контейнер с js-фильтрами
	slotList = document.getElementsByClassName( 'slots-wrap' )[0]; // контейнер со слотами

if ( jsFilter && slotList ) {
	initFilter();
}

function initFilter() {
	jsBtns = jsFilter.getElementsByTagName( 'button' ), //кнопки js-фильтра

		slots = slotList.getElementsByClassName( 'slot' ), //слоты
		slots_data_arr = [],
		data_attr = 'data-sort', // имя атрибута
		jsActiveClass = 'active', //класс для активной кнопки js-фильтра
		jsHideClass = 'hidden'; //класс чтобы скрыть слот
	// checkButtons(); //скроем кнопки для которых нету слотов с указанными производителями
	Array.prototype.forEach.call( jsBtns, function ( el, i ) {
		el.addEventListener( 'click', function () {

			if ( hasClass( this, jsActiveClass ) ) {
				removeClass( el, jsActiveClass );
				showAllSlots();
			} else {
				var data = this.getAttribute( data_attr );
				uncheckActiveFilter(); //убрали актив-класс со всех кнопок фильтра
				disableFilter(); //заблокировали кнопки, чтобы не давили до завершения скрипта
				sortSlots( data ); //перебрали слоты, скрыли - показали
				addClass( this, jsActiveClass ); //подсветили активную кнопку фильтра
				enableFilter(); //разблокировали остальные кнопки
			}

		} );
	} );

	function checkButtons() { //скроем кнопки с атрибутами, которых нет в слотах
		Array.prototype.forEach.call( slots, function ( el, i ) {
			var data = el.getAttribute( data_attr );
			if ( slots_data_arr.indexOf( data ) < 0 ) {
				slots_data_arr.push( data );
			}
		} );
		Array.prototype.forEach.call( jsBtns, function ( el, i ) {
			var data = el.getAttribute( data_attr );
			if ( slots_data_arr.indexOf( data ) < 0 && i > 0 ) { //если атрибута нет в массиве и это не кнопка "Показать все" (i=0 - она в начале списка)
				el.style.display = 'none'; //скроем кнопку фильтра
			}
		} );
		enableFilter();
	}

	function uncheckActiveFilter() { //удалим актив-класс со всех кнопок фильтра
		Array.prototype.forEach.call( jsBtns, function ( el, i ) {
			removeClass( el, jsActiveClass );
		} );
	}

	function disableFilter() { //блокируем кнопки
		Array.prototype.forEach.call( jsBtns, function ( el, i ) {
			el.disabled = true;
		} );
	}

	function enableFilter() { //разблокируем кнопки
		Array.prototype.forEach.call( jsBtns, function ( el, i ) {
			el.disabled = false;
		} );
	}

	function sortSlots( data ) { //перебор слотов
		if ( data == 'all' ) {
			showAllSlots();
		} else {

			Array.prototype.forEach.call( slots, function ( el, i ) {
				console.log( 1 )

				var targetData = el.getAttribute( data_attr );
				if ( data == targetData ) {
					removeClass( el, jsHideClass );
				} else {
					addClass( el, jsHideClass );
				}
			} );
		}
	}

	function showAllSlots() { //покажем все слоты
		Array.prototype.forEach.call( slots, function ( el, i ) {
			removeClass( el, jsHideClass );
		} );
	}
}

//--------------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------------
// HELPERS
//--------------------------------------------------------------------------------------------------------------
function addClass( el, className ) {
	if ( el.classList ) {
		el.classList.add( className );
		el.childNodes[0].src = '/wp-content/themes/6084/img/prod/' + el.dataset.sort + '_hover.svg';
	} else {
		el.className += ' ' + className;
	}

}

function removeClass( el, className ) {
	if ( el.classList ) {
		el.childNodes[0].src = '/wp-content/themes/6084/img/prod/' + el.dataset.sort + '.svg';
		el.classList.remove( className );
	} else {
		el.className = el.className.replace(
			new RegExp( '(^|\\b)' + className.split( ' ' ).join( '|' ) + '(\\b|$)', 'gi' ), ' ' );
	}
}

function hasClass( el, className ) {
	var result = false;
	if ( el.classList ) {
		if ( el.classList.contains( className ) ) {
			result = true;
		}
	} else {
		if ( new RegExp( '(^| )' + className + '( |$)', 'gi' ).test( el.className ) ) {
			result = true;
		}
	}
	return result;
}

function initializeJackpot( id, jackpot ) {

	var jack = document.getElementById( id );
	var numbers = (
		jackpot + ''
	).split( '', - 4 );
	var $j = numbers.reverse();
	var timeinterval = setInterval( function () {
		$j[0] = parseInt( $j[0] ) + randomInteger( 0, 5 );
		if ( $j[0] >= 10 ) {
			$j[0] = parseInt( $j[0] ) - 10;
			$j[1] = parseInt( $j[1] ) + 1;
			if ( $j[1] >= 10 ) {
				$j[1] = 10 - $j[1];
				$j[2] = parseInt( $j[2] ) + 1;
				if ( $j[2] >= 10 ) {
					$j[2] = 10 - $j[2];
					$j[3] = parseInt( $j[3] ) + 1
				}
			}
		}
		if ( $j[0] < 0 ) {
			$j[0] = 0;
			$j[1] = parseInt( $j[1] ) - 1;
			if ( $j[1] < 0 ) {
				$j[1] = 0;
				$j[2] = parseInt( $j[2] ) - 1;
				if ( $j[2] < 0 ) {
					$j[2] = 0;
					$j[3] = parseInt( $j[3] ) - 1;
				}
			}
		}
		$( jack ).find( '.js-countdown__item:last' ).html( $j[0] );
		//console.log($(jack).find('.js-countdown__item').length);
		$( jack ).find( '.js-countdown__item' ).eq(
			parseInt( $( jack ).find( '.js-countdown__item' ).length ) - 2 ).html( $j[1] );
		$( jack ).find( '.js-countdown__item' ).eq(
			parseInt( $( jack ).find( '.js-countdown__item' ).length ) - 3 ).html( $j[2] );
		$( jack ).find( '.js-countdown__item' ).eq(
			parseInt( $( jack ).find( '.js-countdown__item' ).length ) - 4 ).html( $j[3] );


	}, 3000 );
}

function randomInteger( min, max ) {
	var rand = min + Math.random() * (
		max - min
	)
	rand = Math.round( rand );
	return rand;
}

$.each( $( '[data-toggle="jackpot"]' ), function () {
	initializeJackpot( $( this ).attr( "id" ), $( this ).data( 'jack' ) )
} );


(
	function () {
		'use strict';
		//--------------------------------------------------------------------------------------------------------------
		//	LOAD IFRAME GAME
		//--------------------------------------------------------------------------------------------------------------
		(
			function () {
				var wrap = document.getElementById( 'js_game' );
				if ( wrap ) {
					loadGame();
				}

				function loadGame() {
					var btn = wrap.getElementsByTagName( 'button' )[0];
					if ( btn ) {
						btn.addEventListener( 'click', loadFrame );
					}

					function loadFrame() {
						var frame = document.createElement( 'iframe' ),
							src = wrap.getAttribute( 'data-game' );

						frame.setAttribute( 'src', src );
						btn.removeEventListener( 'click', loadFrame );
						wrap.innerHTML = '';
						wrap.appendChild( frame );
					}
				}
			}
		)();
	}
)();
